// extracted by mini-css-extract-plugin
export default {"prettyTable":"ReportView_prettyTable__sNF+G","reportRow":"ReportView_reportRow__LPNFv","reportRowCol":"ReportView_reportRowCol__gXeab"};